import { render, staticRenderFns } from "./SlideMenu.vue?vue&type=template&id=2b7da87e&scoped=true&"
import script from "./SlideMenu.vue?vue&type=script&lang=ts&"
export * from "./SlideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SlideMenu.vue?vue&type=style&index=0&id=2b7da87e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7da87e",
  null
  
)

export default component.exports